<form [formGroup]="form.formGroup">

  <div class="mt-2 mb-2">

    <div class="flex">
      <label class="mr-2" for="isOil">Oil</label>
      <p-toggleswitch
        inputId="isOil"
        [disabled]="isReadOnly"
        [formControlName]="form.formControlNames.isOil"
        (onChange)="isOilChange($event)"
      ></p-toggleswitch>
    </div>

    @if (form.formGroup.controls.isOil.value) {
      <div class="flex flex-col">
        <label for="oilApiGravity">API Gravity</label>
        <app-validated-number-input
          [id]="'oilApiGravity'"
          [control]="oilApiGravityControl"
          [value]="oilApiGravityControl.value"
          [validation]="{ min: 0, max: 200 }"
          [unit]="''">
        </app-validated-number-input>
      </div>
    }

  </div>

  <div class="flex mb-2">
    <label class="mr-2" for="isGas">Gas</label>
    <p-toggleswitch
      inputId="isGas"
      [disabled]="isReadOnly"
      [formControlName]="form.formControlNames.isGas"
      (onChange)="isGasChange($event)"
    ></p-toggleswitch>
  </div>

  <app-gas-composition
    [hidden]="!form.formGroup.controls.isGas.value"
    [formControlName]="form.formControlNames.gasComposition"
    required
    [changeTrigger]="changeTrigger"
  ></app-gas-composition>

</form>
